import type { IconBaseProps, IconType } from "react-icons";

interface SafeIconProps extends IconBaseProps {
  icon: IconType;
}

const SafeIcon = ({ icon: Icon, ...props }: SafeIconProps) => (
  <Icon {...props} />
);

export default SafeIcon;
